import React from 'react';
import {Dropdown, Form, Message} from 'semantic-ui-react';
import _ from 'lodash';
import connectWithCore from 'framework/hocs/connectWithCore';
import {FemaGoModal} from 'app-ui-componentlibrary';
import REST from 'go/requests/rest';
import {toStartCase} from 'common/utils';

export class AdminActionsDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
      reviewers: [],
      groups: [],
      newGroupId: 0,
      newReviewerId: '',
      error: false,
      numActiveReviewers: 0,
    };
  }

  getReviewers = () => {
    const {token, sessionId} = this.props;
    const currentGroup = this.props.panelReviewSessionEntity.groupId;
    const currentReviewers = this.props.panelReviewSessionEntityTasks[0].reviewerList;

    return REST.panelReviewV2
      .getReviewersBySessionAndGroup(token, sessionId, currentGroup)
      .then(REST.handler.handleResponse)
      .then((res) => {
        let reviewerOptions = _.reduce(
          res,
          (reviewerList, reviewer) => {
            if (!_.includes(currentReviewers, reviewer.userId)) {
              reviewerList.push({
                text: `${toStartCase(reviewer.firstName)} ${toStartCase(
                  reviewer.lastName
                )}`,
                value: reviewer.userId,
              });
            }
            return reviewerList;
          },
          []
        );
        let mappedReviewers;
        const uniqueUserIds = _.uniq(
          _.map(reviewerOptions, (reviewer) => _.get(reviewer, 'value'))
        );
        let userIdPayload = {
          userId: uniqueUserIds,
        };
        REST.user
          .getProfilesForUsers(token, userIdPayload)
          .then(REST.handler.handleResponse)
          .then((usersData) => {
            if (!_.isNull(usersData)) {
              mappedReviewers = _.map(reviewerOptions, (reviewer) => {
                const matchUser = _.find(usersData, {
                  userId: _.get(reviewer, 'value'),
                });
                const firstName = _.get(matchUser, 'firstName')
                  ? _.get(matchUser, 'firstName')
                  : '';
                const lastName = _.get(matchUser, 'lastName')
                  ? _.get(matchUser, 'lastName')
                  : '';
                return {
                  ...reviewer,
                  text: `${firstName} ${lastName}`,
                };
              });
              this.setState({
                reviewers: _.sortBy(mappedReviewers, ['text']),
              });
            }
          });
      })
      .catch((err) => {
        this.setState({error: true});
      });
  };

  getGroups = () => {
    const {token, sessionId} = this.props;
    const currentGroup =
      this.props.panelReviewSessionEntity?.groupId ||
      _.map(this.props.panelReviewReviewer?.groups, (group) => group.groupId);

    return REST.panelReviewV2
      .getGroupsBySession(token, sessionId)
      .then(REST.handler.handleResponse)
      .then((res) => {
        let groupOptions = _.reduce(
          res.content,
          (groupList, group) => {
            if (
              (typeof currentGroup === 'object' &&
                !_.includes(currentGroup, group.groupId)) ||
              (typeof currentGroup === 'number' && currentGroup !== group.groupId)
            ) {
              groupList.push({
                text: group.name,
                value: group.groupId,
              });
            }
            return groupList;
          },
          []
        );
        this.setState({
          groups: groupOptions,
        });
      })
      .catch((err) => {
        this.setState({error: true});
      });
  };

  getNumOfActiveReviewers = (token, sessionId, groupId) => {
    return REST.panelReviewV2
      .getGroupBySessionAndGroupId(token, sessionId, groupId)
      .then(REST.handler.handleResponse)
      .then((res) => {
        let numActive = 0;
        _.forEach(res.reviewers, (reviewer) => {
          if (!reviewer.suspended) numActive = numActive + 1;
        });
        this.setState({numActiveReviewers: numActive});
      })
      .catch((err) => {
        this.setState({error: true});
      });
  };

  componentDidMount() {
    const {section} = this.props;
    if (section === 'activeTasks') {
      this.getReviewers();
    } else if (section === 'reviewerInfo' || section === 'entityInfo') {
      this.getGroups();
    } else if (section === 'groupInfo') {
      const {token, panelReviewGroup} = this.props;
      this.getNumOfActiveReviewers(
        token,
        panelReviewGroup.sessionId,
        panelReviewGroup.groupId
      );
    }
  }

  doEntityAction = (actionType) => {
    const {token, sessionId, panelReviewReviewer, panelReviewGroup} = this.props;

    switch (actionType) {
      case 'reassignReviewer':
        this.setState({showModal: 'reassignReviewer'});
        break;
      case 'tableComplete':
        this.setState({showModal: 'tableComplete'});
        break;
      case 'reassignReviewerGroup':
        this.setState({showModal: 'reassignReviewerGroup'});
        break;
      case 'reassignEntityGroup':
        this.setState({showModal: 'reassignEntityGroup'});
        break;
      case 'deactivateReviewer':
        REST.panelReviewV2
          .updateSuspendedDataForReviewer(token, panelReviewReviewer.userId, sessionId, {
            ...panelReviewReviewer,
            suspended: true,
          })
          .then(REST.handler.handleResponse)
          .then((res) => location.reload())
          .catch((err) => {
            this.setState({error: true});
          });
        break;
      case 'activateReviewer':
        REST.panelReviewV2
          .updateSuspendedDataForReviewer(token, panelReviewReviewer.userId, sessionId, {
            ...panelReviewReviewer,
            suspended: false,
          })
          .then(REST.handler.handleResponse)
          .then((res) => location.reload())
          .catch((err) => {
            this.setState({error: true});
          });
        break;
      case 'activateGroup':
        this.updateSuspendedForGroup(
          token,
          panelReviewGroup.groupId,
          sessionId,
          panelReviewGroup,
          false
        );
        break;
      case 'deactivateGroup':
        this.updateSuspendedForGroup(
          token,
          panelReviewGroup.groupId,
          sessionId,
          panelReviewGroup,
          true
        );
        break;
      default:
        break;
    }
  };

  updateSuspendedForGroup = (
    token,
    groupId,
    sessionId,
    panelReviewGroup,
    suspendedVal
  ) => {
    REST.panelReviewV2
      .updateSuspendedDataForGroup(token, groupId, sessionId, {
        ...panelReviewGroup,
        suspended: suspendedVal,
      })
      .then(REST.handler.handleResponse)
      .then((res) => {
        location.reload();
      })
      .catch((err) => {
        this.setState({error: true});
      });
  };

  reassignReviewerModal = () => {
    const {newReviewerId} = this.state;
    const {token, sessionId, entityId, aliases} = this.props;
    const currentReviewerId = this.props.currentReviewerId
      ? this.props.currentReviewerId
      : undefined;
    //defaulting to application if alias does not exist
    const curEntityType = _.get(
      _.find(aliases, {value: 'entityType'}),
      'label',
      'application'
    );
    return (
      <FemaGoModal
        open={this.state.showModal === 'reassignReviewer'}
        title="Reassign reviewer"
        cancelAction={() => {
          this.setState({showModal: false});
        }}
        confirmAction={() => {
          REST.panelReviewV2
            .reassignReviewer(
              token,
              sessionId,
              entityId,
              currentReviewerId,
              newReviewerId
            )
            .then(() => {
              return new Promise((resolve, reject) => {
                this.setState({showModal: false});
                resolve();
              });
            })
            .then(() => {
              location.reload();
            })
            .catch((err) => {
              this.setState({error: true});
            });
        }}
        buttonText={'Reassign reviewer'}
      >
        <Form>
          <p className="pb10">
            {
              'Select a user from the list below to reassign another user to review the entity. To reassign, the user must already be registered in FEMA GO and associated with the panel session. If you do not see a user in the list, the panel admin must first add the user to the panel session in FEMA GO.'
            }
          </p>
          <br />
          <p>
            <strong>Select a reviewer to review the {curEntityType}.</strong>
          </p>
          {this.state.reviewers.length ? (
            <Dropdown
              options={this.state.reviewers}
              placeholder="-Select-"
              selection
              onChange={(e, {name, value}) => {
                this.setState({newReviewerId: value});
              }}
              selectOnNavigation={false}
              selectOnBlur={false}
            />
          ) : (
            <Message info>
              There are no reviewers available for reassignment in this group.
            </Message>
          )}
        </Form>
      </FemaGoModal>
    );
  };

  assignReviewerToGroup = (token, currentGroup, entityId, sessionId, newGroupId) => {
    if (currentGroup.length !== 0) {
      _.forEach(currentGroup, (groupId) => {
        REST.panelReviewV2
          .removeReviewerFromGroup(token, entityId, sessionId, groupId)
          .catch((err) => {
            this.setState({error: true});
          });
      });
    }
    REST.panelReviewV2
      .addReviewerToGroup(token, entityId, sessionId, newGroupId)
      .then(REST.handler.handleResponse)
      .then((res) => {
        this.setState({showModal: false});
        location.reload();
      })
      .catch((err) => {
        this.setState({error: true});
      });
  };

  reassignReviewerGroupModal = () => {
    const textConfig = {
      withGroup: {
        modalTitle: 'Reassign reviewer group',
        buttonText: 'Reassign group',
        modalSubheader: 'Reassign the reveiwer to another group.',
        actionDescription: 'Select an existing group to reassign reviewer.',
      },
      withoutGroup: {
        modalTitle: 'Assign reviewer group',
        buttonText: 'Assign group',
        modalSubheader: 'Assign the reveiwer to a group.',
        actionDescription: 'Select an existing group to assign reviewer.',
      },
    };

    const {token, sessionId, entityId} = this.props;
    const currentGroup = _.map(
      this.props.panelReviewReviewer.groups,
      (group) => group.groupId
    );
    const {modalTitle, buttonText, modalSubheader, actionDescription} =
      currentGroup.length === 0 ? textConfig.withoutGroup : textConfig.withGroup;

    return (
      <FemaGoModal
        open={this.state.showModal === 'reassignReviewerGroup'}
        title={modalTitle}
        cancelAction={() => {
          this.setState({showModal: false});
        }}
        confirmAction={() => {
          this.assignReviewerToGroup(
            token,
            currentGroup,
            entityId,
            sessionId,
            this.state.newGroupId
          );
        }}
        buttonText={buttonText}
      >
        <Form>
          <p className="pb10">{modalSubheader}</p>
          <br />
          <p>
            <strong>{actionDescription}</strong>
          </p>
          <Dropdown
            placeholder="-Select-"
            selection
            options={this.state.groups}
            onChange={(e, {name, value}) => {
              this.setState({newGroupId: value});
            }}
            selectOnNavigation={false}
            selectOnBlur={false}
          />
        </Form>
      </FemaGoModal>
    );
  };

  reassignAppGroupModal = () => {
    const {token, panelReviewSessionEntity, sessionId, entityId} = this.props;
    const curEntityType = _.toLower(
      _.get(panelReviewSessionEntity, 'entityType', 'application')
    );
    return (
      <FemaGoModal
        open={this.state.showModal === 'reassignEntityGroup'}
        title={'Reassign ' + curEntityType + ' group'}
        cancelAction={() => {
          this.setState({showModal: false});
        }}
        confirmAction={() => {
          if (this.state.newGroupId !== 0) {
            const newEntity = {
              ...panelReviewSessionEntity,
              groupId: this.state.newGroupId,
            };
            REST.panelReviewV2
              .updateEntity(token, entityId, sessionId, newEntity)
              .then(this.setState({showModal: false}))
              .catch((err) => {
                this.setState({error: true});
              })
              .finally(() => {
                location.reload();
              });
          } else {
            location.reload();
          }
        }}
        buttonText={'Reassign group'}
      >
        <Form>
          <p className="pb10">
            Reassign the {curEntityType} to another group for review by reviewers.
          </p>
          <br />
          <p>
            <strong>Select an existing group to reassign {curEntityType}.</strong>
          </p>
          <Dropdown
            placeholder="-Select-"
            selection
            options={this.state.groups}
            onChange={(e, {name, value}) => {
              this.setState({newGroupId: value});
            }}
            selectOnNavigation={false}
            selectOnBlur={false}
          />
        </Form>
      </FemaGoModal>
    );
  };

  confirmCloseModal = () => {
    const {token} = this.props;
    const {sessionId, entityId} = this.props;

    return (
      <FemaGoModal
        open={this.state.showModal === 'tableComplete'}
        title="Complete entity review"
        cancelAction={() => {
          this.setState({showModal: false});
        }}
        confirmAction={() => {
          REST.panelReviewV2
            .administrativeClose(token, sessionId, entityId)
            .then(this.setState({showModal: false}))
            .catch((err) => {
              this.setState({error: true});
            });

          location.reload();
        }}
        buttonText={'Confirm'}
      >
        <Form>
          <strong>Confirm review completion?</strong>
        </Form>
      </FemaGoModal>
    );
  };

  render() {
    const {panelReviewSessionEntity, panelReviewReviewer, panelReviewGroup} = this.props;
    const numReviewsRequired = _.get(
      this.props,
      'context.panelReviewSession.numReviewsRequired'
    );
    const status = _.get(
      panelReviewSessionEntity,
      'status',
      _.get(panelReviewReviewer, 'suspended', _.get(panelReviewGroup, 'suspended'))
    );
    const {section} = this.props;
    const {showModal} = this.state;
    let actions = [];
    const groups = _.get(this.props, 'panelReviewReviewer.groups', []);
    const reassignReviewerText = groups.length === 0 ? 'Assign group' : 'Reassign group';

    if (section && status !== undefined && actions.length === 0) {
      actions =
        section === 'activeTasks' && status === 'panelReview'
          ? [
              {
                text: 'Reassign reviewer',
                value: 'reassignReviewer',
                key: 'reassignReviewer',
              },
            ]
          : section === 'entityInfo' && status === 'tableDiscussion'
          ? [{text: 'Move to complete', value: 'tableComplete', key: 'tableComplete'}]
          : section === 'reviewerInfo' && status === false
          ? [
              {
                text: reassignReviewerText,
                value: 'reassignReviewerGroup',
                key: 'reassignReviewerGroup',
              },
              {
                text: 'Deactivate reviewer',
                value: 'deactivateReviewer',
                key: 'deactivateReviewer',
              },
            ]
          : section === 'reviewerInfo' && status === true
          ? [
              {
                text: reassignReviewerText,
                value: 'reassignReviewerGroup',
                key: 'reassignReviewerGroup',
              },
              {
                text: 'Activate reviewer',
                value: 'activateReviewer',
                key: 'activateReviewer',
              },
            ]
          : section === 'entityInfo' && status === 'notStarted'
          ? [
              {
                text: 'Reassign group',
                value: 'reassignEntityGroup',
                key: 'reassignEntityGroup',
              },
            ]
          : section === 'groupInfo' &&
            status === true &&
            this.state.numActiveReviewers >= numReviewsRequired
          ? [
              {
                text: 'Activate group',
                value: 'activateGroup',
                key: 'activateGroup',
              },
            ]
          : section === 'groupInfo' && status === false
          ? [
              {
                text: 'Deactivate group',
                value: 'deactivateGroup',
                key: 'deactivateGroup',
              },
            ]
          : [{text: 'No actions available', value: false}];
    }

    return actions.length ? (
      <React.Fragment>
        {showModal === 'reassignReviewer' && this.reassignReviewerModal()}
        {showModal === 'reassignReviewerGroup' && this.reassignReviewerGroupModal()}
        {showModal === 'reassignEntityGroup' && this.reassignAppGroupModal()}
        {showModal === 'tableComplete' && this.confirmCloseModal()}
        <Dropdown
          selectOnNavigation={false}
          selectOnBlur={false}
          text={'Actions'}
          value={''}
          name="actionButton"
          id="actionButton"
          onChange={(e, {value}) => {
            return this.doEntityAction(value);
          }}
          options={actions}
        />
        <></>
      </React.Fragment>
    ) : null;
  }
}

export default connectWithCore(AdminActionsDropdown);
